var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',[_c('b-tab',{attrs:{"title":("" + (this.$t('menu.settings.alertsNewsletters.titleGeneral'))),"active":""}},[_c('general-bulletin')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":("" + (this.$t('menu.settings.alertsNewsletters.titleBranch')))}},[_c('branch-bulletin')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a435091c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/settings/bulletins/index.vue
// module id = null
// module chunks = 